import React from "react";
import { MessageCircle } from "lucide-react";

export default function WhatsAppButton() {
    return (
        <a
            href="https://wa.me/919999999999?text=Hi%20Veloura%2C%20I%20have%20a%20question."
            target="_blank"
            rel="noreferrer"
            data-testid="whatsapp-button"
            className="fixed z-40 flex items-center gap-2"
            style={{
                bottom: 80,
                right: 20,
                background: "var(--vl-rose)",
                color: "var(--vl-bg)",
                padding: "12px 18px",
                borderRadius: 999,
                boxShadow:
                    "0 10px 30px rgba(183,110,121,0.25), 0 0 0 6px rgba(183,110,121,0.08)",
                fontFamily: "Manrope, sans-serif",
                fontSize: 12,
                letterSpacing: "0.22em",
                textTransform: "uppercase",
                fontWeight: 500,
            }}
        >
            <MessageCircle size={16} strokeWidth={1.5} />
            Concierge
        </a>
    );
}
